module.exports = __webpack_public_path__ + "static/media/dallas.b8456b8d.jpg";